import { AxiosInstance } from 'axios';
import { ITagGroup } from 'src/views/Admin/TagGroups/types';
import { toResponse } from '../../genericToResponse';

export default (api: AxiosInstance, url: string) => async (
  tagGroup: ITagGroup
) => {
  const response = await api.post(url, tagGroup);
  return toResponse(response.data) as ITagGroup;
};



// WEBPACK FOOTER //
// ./src/services/api/admin/tagGroups/add.ts